module.exports = "<div class=\"scoll-container\" [style.left]=\"'-' + scrollOffset + 'px'\">\n    <div class=\"item\"\n         *ngFor=\"let itemData of items; let i = index\"\n         (click)=\"item_click($event, itemData)\"\n         [style.margin-right]=\"itemPadding\"\n         #items>\n\n         <ng-container [ngTemplateOutlet]=\"listItemTemplate\"\n                       [ngTemplateOutletContext]=\"{ item: { isSelected: itemData === selectedItem, data: itemData } }\"></ng-container>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/item-scrollbox/item-scrollbox.component.html
// module id = +QlU
// module chunks = 5